import { Promise } from 'core-js';
import send from '../../utils/fetch'
import {search} from "../../utils/utils";

const state = {
    deposits: [],
}

const actions = {
    async GET_ALL_DEPOSTIS({ commit }) {
        try {
            const {data} = await send(`${global.$url.deposits.get}?start=2021-01-01&end=2021-02-04`, 'GET')
            return data.result
        } catch (e) {
            return Promise.reject(e)
        }
    },
}

const mutations = {
    SET_DEPOSITS(state, data) {
        state.deposits = data
    }
}

const getters = {
    deposits: (state) => state.domains,
}

export default {
    state,
    actions,
    mutations,
    getters
}
